import { render } from "./device-setup.vue?vue&type=template&id=19003504"
import script from "./device-setup.vue?vue&type=script&lang=js"
export * from "./device-setup.vue?vue&type=script&lang=js"

import "./device-setup.vue?vue&type=style&index=0&id=19003504&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__